'use client';
'use strict';

var classes = {"table":"m-b23fa0ef","th":"m-4e7aa4f3","tr":"m-4e7aa4fd","td":"m-4e7aa4ef","tbody":"m-b2404537","thead":"m-b242d975","caption":"m-9e5a3ac7","scrollContainer":"m-a100c15","scrollContainerInner":"m-62259741"};

module.exports = classes;
//# sourceMappingURL=Table.module.css.cjs.map
